module.exports = __webpack_public_path__ + "static/img/bioAcousticSonarImg.52c01c4.png";